const book =[
    {
        id: 1,
        img: "image/data/microsoft-access.svg",
        book : 'https://drive.google.com/file/d/1R-KQQkfQYnE-AqhdNDxjoNxrcFcGhFcg/view?usp=sharing'
    },

    {
        id: 2,
        img: "image/data/sql.svg",
        book : 'https://drive.google.com/file/d/13ow6WsIVyhg0cZNOStmgusLivYEe6_dV/view?usp=sharing'
    }
]

export default book